import doviseGray from "./Logo/svg/dovise-gray.svg";
import doviseIndigo from "./Logo/svg/dovise-indigo.svg";

export const companyLogo = doviseIndigo;
export const loaderLogo = doviseGray;
